import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';


@Component({
  selector: 'service-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card{
      height: 76px;
    }        
  `],
  template: `
    <!--{{service | json}}-->
    <div class="card" [class.border-top]="borderTop" (click)="selectItem($event)">
      <kendo-avatar [imageSrc]="defaultImage" shape="circle" style="background-size: contain; padding: 6px; background-color: #{{ service.service_status_color }}"></kendo-avatar>
      <div class="card-details">
        <div class="card-title" *ngIf="service.id_service_status != 2 && service.id_service_status != 4">
          <span>{{ service.service_status_name }}</span> <span class="right">{{ getDate(service.output_date, true) }}</span>
        </div> 
        <div class="card-title" *ngIf="service.id_service_status == 2 || service.id_service_status == 4">
          <span>{{ intl.formatNumber(service.cost, "c2", "en") }}</span> <span class="right">{{ getDate(service.output_date, true) }}</span>
        </div>                
        <div class="card-subtitle no-wrap">
          {{ service.crane_name }} 
        </div>
        <div class="card-subtitle no-wrap">
          {{ service.place }}, {{ service.person_operator_name }}
        </div>
        <div class="card-subtitle" *ngIf="service.id_service_status == 2 || service.id_service_status == 4">
          {{ service.payment_type_name }} <span class="right">{{ getDate(service.entry_date, true) }}</span>
        </div>
      </div>
      <div class="card-actions" *ngIf="authService.hasPermission(['SALIDAS_SERVICIOS:EDITAR','SALIDAS_SERVICIOS:ELIMINAR'])">
        <span class="k-icon k-icon-md k-i-arrow-chevron-right k-color-secondary" style="color: #{{ service.service_status_color }}!important"></span>
      </div>
    </div>
  `,    
})
export class ServiceCardComponent extends BaseCardComponent {

  @Input() service!: any;

  @Input() defaultImage: string = environment.assets.DEFAULT_SERVICE;

  @Input() returnUrl: string;


  constructor(public intl: IntlService, public router: Router, public authService: AuthService) { 

    super(intl, router)

  }

  public selectItem(event: any) {

    this.router.navigate(['/service_edit/' + this.service.id], {state: {returnUrl: this.returnUrl}});

  }

}